import React from "react";

interface PrizeCardProps {
    prizeName: string;
    points: number;
    playerName: string; // name or null
    coinIconUrl: string;
    playerIcon?: string;
    backgroundColor?: string;
}

const PrizeCard: React.FC<PrizeCardProps> = ({
                                                 prizeName,
                                                 points,
                                                 playerIcon,
                                                 playerName,
                                                 coinIconUrl,
                                                 backgroundColor = "#FF5C5C",
                                             }) => {
    const isClaimed = !!playerName;

    return (
        <div
            style={{
                borderRadius: 20,
                width: "100%",
                margin: "0 auto",
            }}
        >
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor,
                    borderRadius: 16,
                    gap: "5px",
                    padding: "10px",
                    boxShadow: "inset 0 4px 0 rgba(0,0,0,0.2)",
                }}
            >
                <div style={cellStyle}>{prizeName.toUpperCase()}</div>

                <div style={cellStyle2}>
                    <span>{points}</span>
                    <img
                        src={coinIconUrl}
                        alt="coin"
                        style={{
                            width: 20,
                            height: 20,
                            position: "absolute",
                            right: "-10px",
                            top: isClaimed ? "10px" : "6px",
                        }}
                    />
                </div>

                <div
                    style={{
                        ...cellStyle2,
                        width: "100%",
                        paddingTop: 5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: 30,
                    }}
                >
                    {!isClaimed && (
                        <span
                            style={{
                                whiteSpace: "nowrap",
                                fontWeight: "bold",
                                fontSize: 12,
                                color: "rgba(43,18,18,.5)",
                                overflowX: "scroll",
                            }}
                        >
                            Not Claimed
                        </span>
                    )}

                    {isClaimed && (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "6px",
                                overflowX: "scroll"
                            }}
                        >
                            {playerIcon && (
                                <img
                                    src={playerIcon}
                                    alt="player"
                                    style={{
                                        width: 25,
                                        height: 25,
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        flexShrink: 0,
                                    }}
                                />
                            )}
                            <span
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    fontWeight: "bold",
                                    fontSize: 12,
                                    color: "#2E285D",
                                    textAlign: "center",
                                }}
                            >
                                {playerName}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const cellStyle: React.CSSProperties = {
    backgroundColor: "#FDFDFD",
    position: "relative",
    borderRadius: 12,
    fontSize: 12,
    fontWeight: "bold",
    color: "#2E285D",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 90,
};

const cellStyle2: React.CSSProperties = {
    backgroundColor: "#FDFDFD",
    position: "relative",
    borderRadius: 12,
    fontSize: 12,
    fontWeight: "bold",
    color: "#2E285D",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 50,
    marginRight: 8,
    minHeight: 30,
};

export default PrizeCard;
